@if (documentsSpace) {
  <p-card [style]="{ width: '100%' }">
    <div class="card-header p-card-title">
      <i
        class="pi pi-file-pdf"
        style="font-size: 1.5rem"
      ></i>
      <span>
        {{ documentsSpace.name }}
      </span>
      <div class="flex gap-3">
        @if (
          accountService.getAccountName() === documentsSpace.ownerName
          || documentsSpace.admins.includes(accountService.getAccountName())
        ) {
          <button
            class="p-button-outlined"
            pButton
            (click)="openSharedSpaceSetting()"
            type="button"
            label="Modifier"
            i18n-label="@@documents_space_details_edit_button"
            icon="fa fa-sliders"
            [disabled]="documentsSpace.status === 'UPLOADING'"
          ></button>
        }
        @if (accountService.getAccountName() !== documentsSpace.ownerName) {
          <button
            class="p-button-outlined"
            pButton
            (click)="openOwnerHistory()"
            type="button"
            label="Historique du propriétaire"
            i18n-label="@@documents_space_details_owner_history"
            icon="fa fa-sliders"
            [disabled]="documentsSpace.status === 'UPLOADING'"
          ></button>
        }

        <a
          class="p-button p-button-outlined p-button-sm"
          routerLink="/documents-spaces"
        >
          <i class="fa fa-arrow-left mr-2"></i>
          <ng-container i18n="@@document_detail_return_to_list">Retour à la liste</ng-container>
        </a>
      </div>
    </div>
    <div class="mb-2">
      <ng-container i18n="@@document_detail_list_of_files">Liste des fichiers:</ng-container>
    </div>
    @if (documentsSpace.status === "ERROR") {
      <p-messages
        [value]="[
          {
            severity: 'error',
            detail: documentsSpace.errorMessage || 'An error occurred: no detail written in the db',
          },
        ]"
        [enableService]="false"
        [closable]="false"
      />
    }

    @if (documentsSpace.status === "UPLOADING") {
      <p-messages severity="warn">
        <ng-template pTemplate>
          <p-progressSpinner
            styleClass="w-1rem h-1rem mr-2"
            strokeWidth="8"
            animationDuration=".5s"
          />
          <div class="ml-2">
            <ng-container i18n="@@document_detail_uploading_message"
              >Fichiers en cours de traitement, le chat sera bientôt disponible</ng-container
            >
          </div>
        </ng-template>
      </p-messages>
    }

    <div class="flex gap-3">
      @for (file of documentsSpace.files; track file) {
        <span
          class="p-2 border-round-lg surface-300 hover:surface-200 cursor-pointer"
          (click)="downloadFile(file.filepath!, file.filename)"
          aria-disabled="true"
          pTooltip="Télécharger"
          i18n-pTooltip="@@documents_space_download"
          >{{ file.filename }} <i class="pi pi-download"></i
        ></span>
      }
    </div>
    <hr />
    <app-documents-space-chat
      [documentsSpaceId]="documentsSpace.id"
      [isChatEnabled]="documentsSpace.status === 'DONE'"
    />
  </p-card>
}
